import ReconnectingWebSocket from 'reconnecting-websocket';

export default {
  install(Vue, options) {
    // 使用 zysp-user 的 localStorage key
    let token = localStorage.getItem('Authorization') ? localStorage.getItem('Authorization').replace('Bearer ', '') : '';
    if (token) {
      const defaultOptions = {
        url: 'wss://p.lietousaas.com/saas/zysp/ws?system=zysp',
      };
      const finalOptions = { ...defaultOptions, ...options };

      const ws = new ReconnectingWebSocket(finalOptions.url + '&token=' + token);
      const subscribers = {};

      // 封装的sendPayload方法，接收type, data, target，自动组装payload格式
      ws.sendPayload = (type, data, target = 'zysp') => {
        const message = {
          target: target,
          payload: {
            type: type,
            data: data
          }
        };
        // 调用原生send方法，以利用其消息队列功能
        ws.send(JSON.stringify(message));
      };

      ws.subscribe = (messageType, callback) => {
        if (!subscribers[messageType]) {
          subscribers[messageType] = [];
        }
        subscribers[messageType].push(callback);
      };

      ws.unsubscribe = (messageType, callback) => {
        if (subscribers[messageType]) {
          subscribers[messageType] = subscribers[messageType].filter(cb => cb !== callback);
        }
      };

      ws.addEventListener('open', (event) => {
        console.log('连接建立成功', event);
        setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send('ping'); // 使用原生send发送心跳
          }
        }, 30 * 1000);
      });

      ws.addEventListener('message', (event) => {
        if (event.data === 'pong') {
          return;
        }
        console.log('Message from server来自服务器的消息', event);
        try {
          const message = JSON.parse(event.data);
          if (message.type && subscribers[message.type]) {
            subscribers[message.type].forEach(callback => {
              callback(message);
            });
          } else if (subscribers['*']) {
            subscribers['*'].forEach(callback => {
              callback(message);
            });
          }
        } catch (e) {
          console.error('Failed to parse WebSocket message:', e);
        }
      });

      ws.addEventListener('close', (event) => {
        console.log('WebSocket is closed now.现在已关闭', event);
      });

      ws.addEventListener('error', (event) => {
        console.error('WebSocket error observed观察到WebSocket错误:', event);
      });

      Vue.prototype.$websocket = ws;
    } else {
      console.error('Authorization token not found, WebSocket not connected.');
      Vue.prototype.$websocket = {
        send: () => console.error('WebSocket not connected.'),
        sendPayload: () => console.error('WebSocket not connected.'),
        subscribe: () => console.error('WebSocket not connected.'),
        unsubscribe: () => console.error('WebSocket not connected.'),
      };
    }
  }
}